import { LoadingBar } from '@components/gassan-ui'
import { cn } from '@lib/cn'
import { FC } from 'react'

type ProductCardLoadingProps = {
  className?: string
  isFirst?: boolean
  isSecond?: boolean
  color?: string
}

export const ProductCardLoading: FC<ProductCardLoadingProps> = ({
  className,
  isFirst,
  isSecond,
  color,
}) => {
  return (
    <div
      className={cn(
        'pointer-events-none flex w-full flex-col gap-3 md:col-span-2 md:gap-4',
        className,
        isFirst && 'col-span-2 md:col-span-3',
        isSecond && 'md:col-span-3',
      )}
    >
      <LoadingBar className="aspect-square w-full" height="initial" bgColor={color} />
      <div>
        <LoadingBar className="mb-1 h-2 w-3/4" width="intial" bgColor={color} />
        <LoadingBar className="mb-1 h-2 w-1/2" width="intial" bgColor={color} />
        <LoadingBar className="mb-1 h-1 w-3/4" width="intial" bgColor={color} />
        <LoadingBar className="mb-1 h-1 w-1/4" width="intial" bgColor={color} />
      </div>
    </div>
  )
}
